"use strict";var $isNaN=require("./isNaN");module.exports=function(x){return("number"==typeof x||"bigint"==typeof x)&&!$isNaN(x)&&x!==1/0&&x!==-1/0};